import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { AdStrengthColumn as AdStrengthColumnConfig } from '@bingads-webui-campaign/ads-data';

import adStrengthTemplate from './ad-strength.pug';

export class AdStrengthColumn extends CampaignuiBaseColumn {
  constructor({ i18n, newI18n }) {
    super({
      ...AdStrengthColumnConfig,
      title: i18n.getString('ColumnName_AdStrength'),
      sortable: 'AdStrength',
      type: 'string',
      helpId: 'pop_BA_CampaignGrids_AdStrength',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: i18n.getString('ColumnName_AdStrength') }),
    });

    this.i18n = i18n;
    this.SchemaI18n = new SchemaI18n({ i18n });
    this.newI18n = newI18n;
  }

  pickProperty(item) {
    const adStrengthScore = item.Type === 'ResponsiveSearch' ? this.i18n.getString(`Ad_Strength_Score_${item.AdStrength}`) : '-';
    return {
      adStrength: item.AdStrength || !item.$total ? adStrengthScore : '',
      showSuggestion: (item.AdStrengthActionItems && item.AdStrengthActionItems.length > 0) || (item.Type === 'ResponsiveSearch' && item.AdStrength === 'Pending'),
    };
  }

  template({ value }) {
    const { adStrength, showSuggestion } = value;
    return adStrengthTemplate({
      adStrength,
      showSuggestion,
    });
  }
}
